import { Box, Grid, Link, Paper, Tooltip, Typography } from "@mui/material";
import { AvatarCard } from "../Common/AvatarCard";
import logoAzul from "../Recursos/FRIMAmail.jpg";

export default function ComiteEtica() {
    const path = 'https://espolec-my.sharepoint.com/:w:/g/personal/fsmoreno_espol_edu_ec/ETpzy0tfM9BNoDfY2bDNGDMB3lqjTa7D54GvnScdszCrGw?e=1FFeD2'
    return (
        <Grid sx={{ m: 2 }}>
            <Grid className='centrado_centro' container spacing={{ xs: 3, md: 6 }} columns={{ xs: 1, sm: 2, md: 4 }} >
                <img width='200px' height='auto' src={logoAzul} alt="" style={{marginLeft:'10%'}} />
                <Box sx={{ backgroundColor: '#243165', color: '#ffffff', p: 1 }}>
                    <Typography variant="h4" sx={{ fontFamily: 'Playfair, sans-serif' }}>
                        Comité de ética en investigación
                    </Typography>
                </Box>
            </Grid>
            <br />
            <Grid container spacing={{ xs: 3, md: 6 }}>
                <Grid item>                    
                    <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                        El Comité de Ética En Investigación de ESPOL es un órgano colegiado cuyo <strong>objeto</strong> o <strong>finalidad</strong> es revisar, guiar y reglar a los proyectos de investigación, protocolos, estudios, instrumentos, herramientas, actividades y trabajos vinculados o independientes a los proyectos de investigación en I+D+i, bajo <strong>las normas jurídicas, las reglas de la metodología, los principios éticos,</strong> <Tooltip arrow title={'Evaluación del riesgo: proceso por el que se mide la probabilidad a sufrir daños reales, en función del peligro de los elementos, sustancias, organismos o materiales y su forma de manipulación, utilizados e implementados en el desarrollo de los proyectos de investigación, junto a su plan de contingencias.'}><strong>normas técnicas y de seguridad en investigación</strong></Tooltip>, vigente en cada campo de especialización científica.
                    </Typography>
                </Grid>
                <Grid item>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Typography variant="body1">
                            <strong>OBJETIVOS</strong>
                        </Typography>
                        <br />
                        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                            Los objetivos del Comité de Ética en Investigación de la Escuela Superior Politécnica del Litoral son:
                        </Typography>
                        <Box >
                            <Typography variant="body1" sx={{ m: 1 }}><strong>a)</strong> Proteger la dignidad, salvaguardar los derechos y el bienestar de las personas en cualquier actividad de I+D+i. </Typography>
                            <Typography variant="body1" sx={{ m: 1 }}><strong>b)</strong> Exigir la aplicabilidad de las normas de seguridad, el respeto a la naturaleza y ponderar el bienestar de los seres vivos participantes en el diseño y la ejecución de proyectos de I+D+i cuando esto sea posible;</Typography>
                            <Typography variant="body1" sx={{ m: 1 }}><strong>c)</strong> Precautelar los derechos de los investigadores en base al artículo 66 inciso 29 de la Constitución de la República del Ecuador, dispone: “Los derechos de libertad también incluyen: <strong>*apartado d)*</strong> Que ninguna persona pueda ser obligada a hacer algo prohibido o a dejar de hacer algo no prohibido por la ley”. </Typography>
                            <Typography variant="body1" sx={{ m: 1 }}><strong>d)</strong> Precautelar los intereses generales de la ESPOL como persona jurídica pública.</Typography>
                            <Typography variant="body1" sx={{ m: 1 }}><strong>e)</strong> Velar por el cumplimiento de los principios y normas éticas de investigación y bioética en actividades de I+D+i. recogidos en el apartado de considerandos del presente Reglamento.</Typography>
                            <Typography variant="body1" sx={{ m: 1 }}><strong>f)</strong> Precautelar y proteger los derechos, dignidad e integridad física y psicológica de las personas que intervengan en ellos. Cualquier riesgo o afectación sobre los derechos de las personas o la naturaleza, deberá ser legítima, proporcional y necesaria. En los casos pertinentes, se deberá contar con el consentimiento libre, previo e informado de los posibles afectados;</Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Typography variant="body1">
                            <strong>COSTOS</strong>
                        </Typography>
                        <br />
                        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                            Todos los trabajos realizados por el Comité para las facultades, centros de investigación, investigadores y estudiantes adscritos a ESPOL serán gratuitos.
                            Para todos los demás grupos de investigación, Institutos, órganos, investigadores y estudiantes que no estén vinculados a ESPOL, deberán pagar en función del tipo de estudio solicitado.
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Typography variant="body1">
                            <strong>PLAZO DE EMISIÓN DE RESOLUCIONES</strong>
                        </Typography>
                        <br />
                        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                            En función del tipo de estudio solicitado y del nivel de riesgo asignado por el Comité, los plazos pueden variar de entre 20 días para niveles de riesgo bajo y 45 días para los niveles de riesgo alto, el plazo se cuenta a partir de cumplimentar todos los documentos necesarios del proceso.
                        </Typography>
                        <br />                        
                    </Paper>
                </Grid>        
                <Grid item sx={{ width: '100%' }}>
                    <a href={path} target="_blank" rel="noopener noreferrer">
                        EJEMPLO - ELEMENTOS DE UN CONSENTIMIENTO INFORMADO
                    </a>
                </Grid>        
                <Grid item sx={{ width: '100%' }}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Typography variant="body1">
                            <strong>CONTACTO</strong>
                        </Typography>
                        <br />
                        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                            <strong>Oficina:</strong> km 30.5 vía perimetral, Campus Gustavo Galindo. Edificio 3A, 1er piso, Oficina # 001.
                            <br />
                            <Link href="mailto:comiteetica@espol.edu.ec" underline="hover">
                                comiteetica@espol.edu.ec
                            </Link>
                            <br />
                            <strong>Horario de atención:</strong> lunes a viernes de 09:00 a 15:00. 
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
            <br />
            <Paper elevation={2} sx={{ p: 2 }}>
                <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ marginTop: 1 }}>
                    <Grid item xs={6} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="h4">Miembros del comité</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ marginTop: 1 }}>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Dr. Paolo Piedrahita Piedrahita"} cargo={"Presidente"} email={"ppiedra@espol.edu.ec"} />
                    </Grid>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Maria Laura Moreno Fernandez"} cargo={"Secretaria y profesional jurídico"} email="mlmoreno@espol.edu.ec " />
                    </Grid>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Diana Gabriela Carvajal Aldaz"} cargo={"Miembro principal"} />
                    </Grid>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Paola Elizabeth Elizalde Ruiz"} cargo={"Miembro principal"} />
                    </Grid>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Marbel Torres Arias"} cargo={"Miembro principal"} />
                    </Grid>
                    <Grid item sm={12} md={6} lg={6}>
                        <AvatarCard avatarUrl={""} name={"Mathías Max Claude Pecot"} cargo={"Miembro Subrogante"} />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}